export default __webpack_public_path__ + "static/media/logo-web.27f3a4f9.png";